import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {orderLaundryOperation} from '../../../schema/laundryOperation'
import {LaundryOperationModel} from '../../../model'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {TabLavanderiaModel} from '../../../../../models'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {
  createLaundryOperation,
  deleteLaundryOperation,
  updateLaundryOperation,
  uploadTicket,
} from '../../../services'
import {renderPanelContent} from '../components'
import {getDataModified, ShowSnackBar} from '../../../../../util/functions'
import {useAuth} from '../../../../../hooks/useAuth'
import {funcDelete} from '../../../util/function'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_DOWNLOAD,
} from '../../../../../util/Constants'
const LaundryOperationPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {user} = useAuth()

  const [loading, setLoading] = useState(false)
  const methods = useForm<LaundryOperationModel>({
    resolver: yupResolver(orderLaundryOperation),
  })
  const {reset} = methods

  const handleDelete = async () => {
    await funcDelete(
      deleteLaundryOperation,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: LaundryOperationModel) => {
    try {
      setLoading(true)
      data = getDataModified(data)
      data.usuarioId = user.id
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createLaundryOperation(data)
        : await updateLaundryOperation({...data, id: currentTabItem.idToEdit})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: isCreating ? true : false,
          currentExternalTab: isCreating ? 1 : undefined,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-operation',
            detailPanel: isCreating ? 'tab-operation' : undefined,
          },
          idToEdit: response.data.messageSystem,
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.message ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }

    setLoading(false)
  }
  const handleGenerate = async () => {
    setLoading(true)
    let id = currentTabItem.idToDelete

    try {
      const response = await uploadTicket(id)
      if (!response.data.error) {
        const blob = new Blob([response.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Ticket_' + currentTabItem.aditionalInformation?.order?.nroOrden // Ajusta el nombre del archivo según tus necesidades
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        ShowSnackBar(SUCCESS_MESSAGE_DOWNLOAD)
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      ShowSnackBar('Error interno', 'error')
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          option='order'
          generateTicket={handleGenerate}
          loading={loading}
          textComponentBack='table-operation'
          textComponentGo='form-operation'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default LaundryOperationPageWrapper
